export default {"src":"/_next/static/media/iconNavSelectedBlue.149c95c4.svg","height":6,"width":20,"blurWidth":0,"blurHeight":0};